var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from "react";
var combineHeaders = function (params) {
    return Object.keys(params)
        .map(function (key) { return "".concat(key, "=").concat(encodeURIComponent(params[key])); })
        .join("&");
};
var generateLink = function (_a) {
    var email = _a.email, headers = _a.headers, tel = _a.tel, sms = _a.sms, facetime = _a.facetime, href = _a.href, children = _a.children;
    if (email) {
        var link = "mailto:".concat(email);
        if (headers) {
            link += "?".concat(combineHeaders(headers));
        }
        return link;
    }
    if (tel) {
        return "tel:".concat(tel);
    }
    if (sms) {
        return "sms:".concat(sms);
    }
    if (facetime) {
        return "facetime:".concat(facetime);
    }
    if (href) {
        return href;
    }
    if (typeof children !== "object") {
        return children;
    }
    return "";
};
var Obfuscate = function (_a) {
    var _b = _a.element, element = _b === void 0 ? "a" : _b, children = _a.children, tel = _a.tel, sms = _a.sms, facetime = _a.facetime, email = _a.email, href = _a.href, headers = _a.headers, obfuscate = _a.obfuscate, obfuscateChildren = _a.obfuscateChildren, linkText = _a.linkText, style = _a.style, onClick = _a.onClick, others = __rest(_a, ["element", "children", "tel", "sms", "facetime", "email", "href", "headers", "obfuscate", "obfuscateChildren", "linkText", "style", "onClick"]);
    var _c = useState(false), humanInteraction = _c[0], setHumanInteraction = _c[1];
    var linkProps = children || tel || sms || facetime || email || href;
    var Component = element;
    var handleClick = function () {
        // Allow instantiator to provide an onClick method to be called
        // before we change location (e.g. for analytics tracking)
        if (onClick && typeof onClick === "function") {
            onClick();
        }
        // If focused or hovered, this js will be skipped with preference for html
        if (humanInteraction === false) {
            window.location.href = generateLink({
                email: email,
                headers: headers,
                tel: tel,
                sms: sms,
                facetime: facetime,
                href: href,
                children: children,
            });
        }
    };
    var reverse = function (content) {
        return typeof content === "string" &&
            content.split("").reverse().join("").replace("(", ")").replace(")", "(");
    };
    var renderedLink = humanInteraction === true ||
        obfuscate === false ||
        typeof children === "object" ||
        obfuscateChildren === false // Allow child elements
        ? linkProps
        : reverse(linkProps);
    var clickProps = Component === "a"
        ? {
            href: humanInteraction === true || obfuscate === false
                ? generateLink({
                    email: email,
                    headers: headers,
                    tel: tel,
                    sms: sms,
                    facetime: facetime,
                    href: href,
                    children: children,
                })
                : linkText || "obfuscated",
            onClick: handleClick,
        }
        : {};
    return (React.createElement(Component, __assign({ onFocus: function () { return setHumanInteraction(true); }, onMouseOver: function () { return setHumanInteraction(true); }, onContextMenu: function () { return setHumanInteraction(true); } }, others, clickProps, { style: __assign(__assign({}, style), { unicodeBidi: "bidi-override", direction: humanInteraction === true ||
                obfuscate === false ||
                obfuscateChildren === false
                ? "ltr"
                : "rtl" }) }), renderedLink));
};
export default Obfuscate;
